module.exports = __webpack_public_path__ + "img/section26.b78206c1.png";